/**
 * @nanokart/tryon-studio-sdk
 * API Services Index
 */

export {
  createApiClient,
  type ApiClient,
  type ApiClientConfig,
  type ApiResponse,
  type ApiError,
} from './client';

export {
  TryOnApiService,
  type TryOnStudioApiResponse,
} from './tryonApi';

export {
  MomentsApiService,
  MOMENT_TYPE_VALUES,
  MOMENT_TYPE_DEFINITIONS,
  type MomentTypeValue,
  type MomentTypeDefinition,
  type MomentsStudioApiResponse,
} from './momentsApi';

export {
  SizeApiService,
  type SizeRecommendRequest,
  type SizeRecommendResponse,
  type SizeChartResponse,
} from './sizeApi';

import { createApiClient, ApiClientConfig } from './client';
import { TryOnApiService } from './tryonApi';
import { MomentsApiService } from './momentsApi';
import { DEFAULT_API_BASE_URL } from '../../types/config';

/**
 * All API services with shared client
 */
export interface ApiServices {
  tryon: TryOnApiService;
  moments: MomentsApiService;
}

/**
 * Create all API services configured for the TryOn Studio SDK.
 * Auth header: X-API-Key: <apiKey>
 */
export function createApiServices(apiKey: string, apiBaseUrl?: string): ApiServices {
  const config: ApiClientConfig = {
    baseUrl: apiBaseUrl ?? DEFAULT_API_BASE_URL,
    headers: {
      'X-API-Key': apiKey,
    },
    timeout: 90000, // 90s for AI generation
  };

  const client = createApiClient(config);

  return {
    tryon: new TryOnApiService(client),
    moments: new MomentsApiService(client),
  };
}
